import { pageSEO } from "./seoConfig";
import { blogPosts } from "./blogData";
import { getAllSectors } from "./sectorData";

export interface PublicPage {
  path: string;
  label: string;
  title: string;
  description: string;
  group: "Company" | "Packaging sectors" | "Insights";
}

const mainPages: { key: keyof typeof pageSEO; label: string }[] = [
  { key: "home", label: "Home" },
  { key: "forCompanies", label: "For Packaging Companies" },
  { key: "forCandidates", label: "For Sales Candidates" },
  { key: "process", label: "Our Retained Search Process" },
  { key: "caseStudies", label: "Case Studies" },
  { key: "packagingSectors", label: "Packaging Sectors" },
  { key: "about", label: "About Chris Kenny" },
  { key: "contact", label: "Contact OC Recruitment" },
  { key: "insights", label: "Insights" },
];

export function getPublicPages(): PublicPage[] {
  return [
    ...mainPages.map(({ key, label }) => ({
      path: pageSEO[key].canonical,
      label,
      title: pageSEO[key].title,
      description: pageSEO[key].description,
      group: "Company" as const,
    })),
    { path: "/site-map", label: "Website Sitemap", title: "Website Sitemap | OC Recruitment", description: "Browse OC Recruitment's retained-search services, eight packaging sectors, hiring insights, and contact information for US packaging sales recruitment.", group: "Company" as const },
    ...getAllSectors().map(sector => ({
      path: `/sectors/${sector.slug}`,
      label: sector.name,
      title: sector.metaTitle,
      description: sector.metaDescription,
      group: "Packaging sectors" as const,
    })),
    ...blogPosts.map(post => ({
      path: `/insights/${post.slug}`,
      label: post.title,
      title: post.metaTitle,
      description: post.metaDescription,
      group: "Insights" as const,
    })),
  ];
}

export function resolvePublicPage(url: string): PublicPage | undefined {
  let pathname = url.split("?")[0];
  try { pathname = decodeURI(pathname); } catch { /* keep malformed path unchanged */ }
  return getPublicPages().find(page => page.path === pathname);
}
